import { Typography } from '@safedns/skydns-ui-react-lib';

const NotFound = ({ text }) => {
  return (
    <div style={{ textAlign: 'center' }}>
      <Typography
        sx={{
          mb: '12px',
          fontSize: '72px',
          fontWeight: 600,
          lineHeight: '80px',
        }}
      >
        404
      </Typography>
      <Typography
        sx={{
          fontSize: '20px',
          fontWeight: 500,
          lineHeight: '28px',
        }}
      >
        {text}
      </Typography>
    </div>
  );
};

export default NotFound;
